import api from 'Application/api/api';

const deleteInstructionArea = (id, cancelToken = null) =>
    api.delete(`/education/instruction-areas/${id}`, { cancelToken });

export default deleteInstructionArea;
